// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1qWDL","messages":"Chat_messages__3GuXN","dateDivider":"Chat_dateDivider__7vW00"};